import {
    addBOInstanceTags,
    cloneBoInstance,
    deleteBOInstanceTags,
    deleteInstances,
    downloadZip,
    importV2,
    manageDataExport,
    mergeInstances,
    submit,
    transferInferenceMismatchRecords,
    updateInstance, uploadFile, uploadFiles
} from '../../../../actions/boCoreActions';
import * as React                           from 'react';
import {connect}                            from 'react-redux';
import history                              from '../../../../config/history';
import urlencode                            from "urlencode";
import * as toastr                          from "toastr";
import AgGridTagsQtip                       from '../../common/AgGridTagsQtip';
import * as agGrid                          from "ag-grid-community/main";
import {BusinessObjectBaseInterface}        from "../../Interfaces/BusinessObjectBaseInterface";
import {Instance}                           from "../../models/Instance";
import {AttributeTypeEnum}                  from "../../enums/AttributeTypeEnum";
import AgSelectAllHeader                    from "../../common/AgSelectAllHeader";
import AgGridFooter                         from "../../common/AgGridFooter";
import {BusinessObjectWrapperInterface}     from "../../Interfaces/BusinessObjectWrapperInterface";
import {DataTypesEnum}                      from "../../enums/dataTypesEnum";
import {AttributeInterface}                 from "../../Interfaces/AttributeInterface";
import {Relationship}                       from "../../models/Relationship";
import {RelationshipInterface}              from "../../Interfaces/RelationshipInterface";
import AgHelpToolTip, {helpHeaderTemplate}  from '../../common/AgHeaderHelpToolTip'
import GlobalSearchHelpToolTip              from "../../common/GlobalSearchHelpToolTip";
import Utils                                from "../../../../Utils";
import Axios                                from "../../../../config/Axios";
import camelcase                            from "camelcase";
import ActionSpinner                        from "../../../common/ActionSpinner";
import getAttributesEditor                  from "../../common/AgInstanceAttributes";
import LookupInstanceModal                  from "../../modals/LookupInstanceModal";
import {Ref}                                from "react";
import _                                    from "lodash";
import getManageDataEditor                  from "./components/ManageDataSelector";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import {setLastSearch} from "../../../../actions/lastSearchActions";
import {actions, setSelectedSearch} from "../../../../actions/savedSearchActions";

import {slide as Menu} from 'react-burger-menu'
import AgGridUtils from "../../../../AgGridUtils";

const FileSaver = require("file-saver");

const $importTargetContentModel = Utils.$('<div id="qtipContainerImport"></div>')
    .append($("<label>What format would you like multi-valued attributes to be imported in:</label>"))
    .append($("<input id='multiValueToggle' type='checkbox' data-onstyle='danger' data-offstyle='primary' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<div style='padding-top: 5px' id='buttons-container'/>")
        .append($("<input id='choose-files' style='float: left' type='file' accept='.tsv' />"))
        .append($("<input id='submit-files' type='button' style='float: right; color: black' value='Submit'/>")));

const $mergeRecordsContentModel = Utils.$('<div id="qtipContainerMerge"></div>')
    .append($("<label>Do you want relationships to be merged?</label>"))
    .append($("<input id='multiValueToggle' class='merge-toggle' type='checkbox' data-onstyle='danger' data-offstyle='primary' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<div style='padding-top: 5px' id='buttons-container'/>"));

const $exportTargetContentModel = Utils.$('<div id="qtipContainerExport"></div>')
    .append($("<label>What format would you like multi-valued attributes to be exported in:</label>"))
    .append($("<input id='multiValueToggle' type='checkbox' data-onstyle='danger' data-offstyle='primary' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<label style='padding-top: 5px'>Which grid columns would you like to be exported:</label>"))
    .append($("<input id='dataViewToggle' type='checkbox' data-onstyle='danger' data-offstyle='primary' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<ul id='export-progress-list' style='list-style-type: none; max-height: 200px; overflow-y: auto; padding-top: 5px'/>"))
    .append($("<label>Export as:</label>"))
    .append($("<button id='tsv-btn' style='margin-right: 5px; width: 107px; background-color: #d89314' class='btn'>TSV</button>"))
    .append($("<button id='xlsx-btn' style='margin-right: 5px; width: 107px; background-color: #56b919' class='btn'>XLSX</button>"))
    .append($("<button id='json-btn' style='width: 106px; background-color: #b53f24;' class='btn'>JSON</button>"));

const $cloneTargetContentModel = Utils.$('<div id="qtipContainer"></div>')
    .append($("<label>How many copies would you like to create?</label>"))
    .append($("<input id='numberOfCopies' style='border: 1px solid #9f9f9f; background: #2D3436; color: #b5b5b5; width: 100%; height: 30px; font-size: 14px' type='number' value='1' max='999' min='1'/>"))
    .append($("<label style='padding-top: 5px'>Clone Relationships:</label>"))
    .append($("<input id='cloneRelsToggle' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<label style='padding-top: 5px'>Clone Related Instances:</label>"))
    .append($("<input disabled='true' id='cloneRelatedInstances' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<label style='padding-top: 5px'>Share Cloned Related Instances:</label>"))
    .append($("<input disabled='true' id='shareClonedInstances' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<input id='submitCopies' class='btn btn-success' type='submit' style='margin-top: 15px; width: 100%;' value='Submit'/>"));


const $uploadFile = Utils.$('<div id="qtipContainerImport"></div>')
        .append($("<label>Are Files Public:</label>"))
        .append($("<input id='multiValueToggle' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
        .append($("<div style='padding-top: 5px' id='buttons-container'/>")
        .append($("<input id='choose-files' style='float: left' type='file' multiple />"))
        .append($("<input id='submit-files' type='button' style='float: right; color: black' value='Submit'/>")));

interface Props {
    tagsSet: any;
    currentDataView: any
    currentBusinessObject: BusinessObjectBaseInterface;
    businessObjectsWrapper: BusinessObjectWrapperInterface;
    selectedSearch: any;
    locale: {value: string, label: string}

    downloadZip(ids: number[], fileName: string): void;

    deleteInstances(ids: number[], onSuccessCallback: any);

    addBOInstanceTags(currentInstance: any, originalInstance: any, tags: any);

    deleteBOInstanceTags(currentInstance: any, originalInstance: any, tags: any);

    setLastSearch(obj: any): void;

    setSelectedSearch(obj: any); void;

    handleSelectedSearch(obj: any): void;

    onBusinessObjectChange(item: any, search?: any): void;
}

export enum ResizeActions {
    FIT_CONTENT = 'Fit Content',
    FIT_SCREEN = 'Fit Screen'
}
interface State {
    grid: any;
    $importTargetContent: any;
    $exportTargetContentModel: any;
    $mergeRecordsContent: any;
    $cloneTargetContentModel: any;
    $uploadFile: any;
    margeIntoId: number,
    mergeRelationships: boolean;
    inplaceEditEnabled: boolean;
    isInferenceTemp: boolean;
    burgerMenuIsOpen: boolean;
    resizeAction: string;
}
let prevInputValuesCounter:number = 0
class ManageDataGrid extends React.Component<Props, State> {
    private timeout: any = 0;
    private importSpecModal: any;
    private _isMounted: boolean = false;
    private lookupUpdateParams: any = null;
    private isInitialBuild: boolean = false;
    private lastExecutedQuery: any = null;
    private lastDataArray: any = [];

    private readonly lookupInstanceModalRef: Ref<any> = React.createRef();

    constructor(props: Props) {
        super(props);
        this.state = {
            grid: null,
            $importTargetContent: $importTargetContentModel.clone(),
            $exportTargetContentModel: $exportTargetContentModel.clone(),
            $mergeRecordsContent: $mergeRecordsContentModel.clone(),
            $cloneTargetContentModel: $cloneTargetContentModel.clone(),
            $uploadFile: $uploadFile.clone(),
            margeIntoId: -1,
            mergeRelationships: false,
            inplaceEditEnabled: false,
            isInferenceTemp: false,
            burgerMenuIsOpen: false,
            resizeAction: ResizeActions.FIT_CONTENT,
        }
    }

    componentDidMount() {
        this._isMounted = true;
        const {currentDataView, currentBusinessObject} = this.props;
        if (currentBusinessObject && currentDataView) {
            if (currentBusinessObject.inferenceTemp) {
                this.setState({
                    inplaceEditEnabled: true
                }, () => {
                    document.getElementById("inplace-edit-btn").classList.add('inplace-edit-active');
                    this.build(currentBusinessObject, currentDataView, true)
                });
            } else {
                this.build(currentBusinessObject, currentDataView)
            }
        }
        document.addEventListener('keydown', this.keydownHandler);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        const {currentDataView, selectedSearch} = this.props;
        if (((currentDataView.id !== prevProps.currentDataView.id)) || (selectedSearch !== null && !_.isEqual(prevProps.selectedSearch, selectedSearch))) {
            this.saveGridState()
            this.state.grid.gridOptions.api.destroy();
            this.build(this.props.currentBusinessObject, currentDataView, false, currentDataView.id !== prevProps.currentDataView.id);
        }
    }

    componentWillUnmount(): void {
        this._isMounted = false;
        if (this.state.grid?.gridOptions?.api) {
            this.state.grid.gridOptions.api.destroy();
        }
        document.removeEventListener('keydown', this.keydownHandler);
        $("#hide-nav-btn").off();
        // remove remaining datepicker
        Utils.$('.xdsoft_datetimepicker').remove();
        Utils.$('#ui-datepicker-div').remove();
        // remove remaining select
        Utils.$('#select2-drop').remove();
        Utils.$('#select2-drop-mask').remove();
    }

    openBurgerMenu = (btnId?:string) => {
        if (btnId) {
            this.setState({
                burgerMenuIsOpen: true
            }, () => {
                setTimeout(() => {
                    Utils.$(`#${btnId}`).click();
                },200)
            })
        } else {
            this.setState({
                burgerMenuIsOpen: !this.state.burgerMenuIsOpen
            })
        }
    }

    closeBurgerMenu = () => {
        this.setState({
            burgerMenuIsOpen: false
        })
    }

    keydownHandler = (e) => {
        if (e.ctrlKey && e.altKey && e.keyCode === 66) {
            Utils.$('#bulk-update-button').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 78) {
            if (this.props.currentBusinessObject.name.toLowerCase() === 'file') {
                Utils.$('#new-file-btn').click();
            } else {
                Utils.$('#new-instance-btn').click();
            }
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 67) {
            this.openBurgerMenu('clone-instance-btn')
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 71) {
            Utils.$('#merge-instance-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 88) {
            this.openBurgerMenu('export-btn')
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 80) {
            Utils.$('#expand-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 69) {
            Utils.$('#edit-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 73) {
            this.openBurgerMenu('import-btn')
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#delete-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 79) {
            Utils.$('#download-btn').click();
        }
        if(e.shiftKey && e.keyCode === 38) {
            Utils.$('#manage-data-search').focus();
        }
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 76) {
            Utils.$('#inplace-edit-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 82) {
            Utils.$('#clear-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 84) {
            Utils.$('#edit-raw-btn').click();
        }
        if (e.keyCode === 9) {
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    if (e.keyCode === 9) {
                        e.preventDefault();

                        // scrolls to the first row
                        this.state.grid.gridOptions.api.ensureIndexVisible(0);

                        // scrolls to the current column
                        let currentCol = this.state.grid.gridOptions.columnApi.getAllDisplayedColumns()[0];
                        this.state.grid.gridOptions.api.ensureColumnVisible(currentCol);

                        // sets focus into the grid cell
                        this.state.grid.gridOptions.api.setFocusedCell(0, currentCol);
                    }
                }
            }
        }
    };

    getBusinessObject = (businessObject) => {
        return {
            id: businessObject.id,
            name: businessObject.name,
            attributes: (businessObject.getAttributes(DataTypesEnum.ARRAY) as AttributeInterface[]).map(item => {
                const lookupAttribute = this.props.businessObjectsWrapper.getAttributeById(item.lookupAttributeId);
                return {
                    id: item.id,
                    name: item.name,
                    boClass: item.boClass,
                    createRelationships: item.createRelationships,
                    defaultValue: item.defaultValue,
                    description: item.description,
                    lookupRelTypeId: item.lookupRelTypeId,
                    lookupAttribute: lookupAttribute ? {
                        boClass: lookupAttribute.boClass,
                        id: lookupAttribute.id,
                        name: lookupAttribute.name
                    } : null,
                    maxDigitsLeftOfDecimal: item.maxDigitsLeftOfDecimal,
                    maxLength: item.maxLength,
                    minDigitsRightOfDecimal: item.minDigitsRightOfDecimal,
                    minLength: item.minLength,
                    prefix: item.prefix,
                    regexValidation: item.regexValidation,
                    required: item.required,
                    suffix: item.suffix,
                    systemRequired: item.systemRequired,
                    type: item.type,
                    uiSection: item.uiSection,
                    unitOfMeasure: item.unitOfMeasure,
                    attributeValues: (item.getAttributeValues(DataTypesEnum.ARRAY) as []).map((item: any) => {
                        return {
                            id: item.id,
                            name: item.name,
                            description: item.description
                        }
                    })
                }
            }) as any[],
            relationships: (businessObject.getRelationships(DataTypesEnum.ARRAY) as Relationship[]).map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    inward: item.inward,
                    outward: item.outward,
                    systemRequired: item.systemRequired,
                    toBoClass: {
                        id: item.toBoClass.id,
                        name: item.toBoClass.name,
                        description: item.toBoClass.description,
                        relationships: (this.props.businessObjectsWrapper.getBusinessObject(item.toBoClass.id).getRelationships(DataTypesEnum.ARRAY) as RelationshipInterface[]).map(item => {
                            return {
                                id: item.id,
                                name: item.name,
                                inward: item.inward,
                                outward: item.outward,
                                toBoClass: item.toBoClass,
                                fromBoClass: item.fromBoClass
                            }
                        }),
                        attributes: (this.props.businessObjectsWrapper.getBusinessObject(item.toBoClass.id).getAttributes(DataTypesEnum.ARRAY) as AttributeInterface[]).map(item => {
                            const lookupAttribute = this.props.businessObjectsWrapper.getAttributeById(item.lookupAttributeId);
                            return {
                                id: item.id,
                                name: item.name,
                                boClass: item.boClass,
                                createRelationships: item.createRelationships,
                                defaultValue: item.defaultValue,
                                description: item.description,
                                lookupRelTypeId: item.lookupRelTypeId,
                                lookupAttribute: lookupAttribute ? {
                                    boClass: lookupAttribute.boClass,
                                    id: lookupAttribute.id,
                                    name: lookupAttribute.name
                                } : null,
                                maxDigitsLeftOfDecimal: item.maxDigitsLeftOfDecimal,
                                maxLength: item.maxLength,
                                minDigitsRightOfDecimal: item.minDigitsRightOfDecimal,
                                minLength: item.minLength,
                                prefix: item.prefix,
                                regexValidation: item.regexValidation,
                                required: item.required,
                                suffix: item.suffix,
                                systemRequired: item.systemRequired,
                                type: item.type,
                                uiSection: item.uiSection,
                                unitOfMeasure: item.unitOfMeasure,
                                attributeValues: (item.getAttributeValues(DataTypesEnum.ARRAY) as []).map((item: any) => {
                                    return {
                                        id: item.id,
                                        name: item.name,
                                        description: item.description
                                    }
                                })
                            }
                        }) as any[]
                    },
                    fromBoClass: {
                        id: item.fromBoClass.id,
                        name: item.fromBoClass.name,
                        description: item.fromBoClass.description,
                        relationships: (this.props.businessObjectsWrapper.getBusinessObject(item.fromBoClass.id).getRelationships(DataTypesEnum.ARRAY) as RelationshipInterface[]).map(item => {
                            return {
                                id: item.id,
                                name: item.name,
                                inward: item.inward,
                                outward: item.outward,
                                toBoClass: item.toBoClass,
                                fromBoClass: item.fromBoClass
                            }
                        }),
                        attributes: (this.props.businessObjectsWrapper.getBusinessObject(item.fromBoClass.id).getAttributes(DataTypesEnum.ARRAY) as AttributeInterface[]).map(item => {
                            const lookupAttribute = this.props.businessObjectsWrapper.getAttributeById(item.lookupAttributeId);
                            return {
                                id: item.id,
                                name: item.name,
                                boClass: item.boClass,
                                createRelationships: item.createRelationships,
                                defaultValue: item.defaultValue,
                                description: item.description,
                                lookupRelTypeId: item.lookupRelTypeId,
                                lookupAttribute: lookupAttribute ? {
                                    boClass: lookupAttribute.boClass,
                                    id: lookupAttribute.id,
                                    name: lookupAttribute.name
                                } : null,
                                maxDigitsLeftOfDecimal: item.maxDigitsLeftOfDecimal,
                                maxLength: item.maxLength,
                                minDigitsRightOfDecimal: item.minDigitsRightOfDecimal,
                                minLength: item.minLength,
                                prefix: item.prefix,
                                regexValidation: item.regexValidation,
                                required: item.required,
                                suffix: item.suffix,
                                systemRequired: item.systemRequired,
                                type: item.type,
                                uiSection: item.uiSection,
                                unitOfMeasure: item.unitOfMeasure,
                                attributeValues: (item.getAttributeValues(DataTypesEnum.ARRAY) as []).map((item: any) => {
                                    return {
                                        id: item.id,
                                        name: item.name,
                                        description: item.description
                                    }
                                })
                            }
                        }) as any[]
                    }
                }
            }) as any[]
        }
    };

    onNewHandler = () => {
        this.saveGridState();
        switch (this.props.currentBusinessObject.name.toLowerCase()) {
            case Utils.SysRuleEngineRules:
                history.push({
                    pathname: `${process.env.ENV_PREFIX}/rules/-1`,
                    state: {
                        bocId: this.props.currentBusinessObject.id,
                    }
                });
                break;
            case Utils.SysRuleEngineActions:
                history.push({
                    pathname: `${process.env.ENV_PREFIX}/actions/-1`,
                    state: {
                        bocId: this.props.currentBusinessObject.id,
                    }
                });
                break;
            default:
                history.push(`${process.env.ENV_PREFIX}/instance/-1?bocId=${this.props.currentBusinessObject.id}`);
        }
    };

    onUpdateSGP = () => {
        ActionSpinner.get("sgp-update-master", {}, {key: "updateSGP", showOnError: true, showOnSuccess: true})
            .then(() => {
                this.onFilterTextBoxChanged({type: "click"});
            })
    };

    saveGridState = () => {
        window['sortState'] = this.state.grid.gridOptions.api.getSortModel();
        window['filterState'] = this.state.grid.gridOptions.api.getFilterModel();
    };

    restoreGridState = (gridOptions: any) => {
        gridOptions.api.setSortModel(window['sortState']);
        gridOptions.api.setFilterModel(window['filterState']);
        if (window['filterState'] && window['filterState']['quickFilter']) {
            $(this.refs.quickFilterBox).val(window['filterState']['quickFilter'].filter)
        }
    };

    onEditHandler = () => {
        const item = this.state.grid.gridOptions.api.getSelectedRows()[0];
        if (item) {
            this.saveGridState();
            switch (this.props.currentBusinessObject.name.toLowerCase()) {
                case Utils.SysRuleEngineRules:
                    history.push({
                        pathname: `${process.env.ENV_PREFIX}/rules/${item.id}`,
                        state: {
                            bocId: this.props.currentBusinessObject.id,
                            instanceId: item.id
                        }
                    });
                    break;
                case Utils.SysRuleEngineActions:
                    history.push({
                        pathname: `${process.env.ENV_PREFIX}/actions/${item.id}`,
                        state: {
                            bocId: this.props.currentBusinessObject.id,
                            instanceId: item.id
                        }
                    });
                    break;
                default:
                    history.push(`${process.env.ENV_PREFIX}/instance/${item.id}`);
            }
        } else {
            toastr.warning('Please select an instance you want to edit.');
        }
    };

    onBulkUpdate = () => {
        const selectedRows = this.state.grid.gridOptions.api.getSelectedRows();
        if (selectedRows.length > 1) {
            this.saveGridState();
            const currentBusinessObject = this.props.currentBusinessObject;
            currentBusinessObject.uniqueName = this.props.businessObjectsWrapper.getBusinessObject(currentBusinessObject.id).uniqueName;
            history.push(`${process.env.ENV_PREFIX}/bulk-update`, {
                businessObject: currentBusinessObject,
                instanceIds: selectedRows.map(row => row.id),
                dataView: {
                    _viewName: this.props.currentDataView._viewName
                }
            });
        } else {
            toastr.warning('Please select at least 2 instances.');
        }
    };

    onEditRawHandler = () => {
        const item = this.state.grid.gridOptions.api.getSelectedRows()[0];
        if (item) {
            this.saveGridState();
            history.push(`${process.env.ENV_PREFIX}/instance/${item.id}`);
        } else {
            toastr.warning('Please select an instance you want to edit.');
        }
    };

    onDeleteHandler = () => {
        const ids = this.state.grid.gridOptions.api.getSelectedRows().map(item => item.id);
        Utils.$('#delete-btn').blur();
        if (ids.length > 0) {
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: `You are about to delete ${ids.length} instances, this procedure is irreversible.`,
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            this.props.deleteInstances(ids, () => {
                                this.state.grid.gridOptions.api.deselectAll();
                                this.onFilterTextBoxChanged({type: "click"});
                                this.closeBurgerMenu()
                            });
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        } else {
            toastr.warning('Please select an instance you want to delete.');
        }
    };

    onOpenImportDialog = (e) => {
        const $importTargetContent = this.state.$importTargetContent.clone();
        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Manage Data Import"
                },
                text: $importTargetContent,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            events: {
                show: () => {
                    $(e.target).css("background-color", "#676A6C");
                },
                hide: () => {
                    Utils.$(e.target).css("background-color", "#1AB394");
                    Utils.$('.qtip-dark').remove();
                    Utils.$(e.target).qtip('destroy');
                },
                visible: () => {
                    document.getElementById("choose-files").focus();
                },
                render: () => {
                    let multiValueFormat = "PIPE";
                    let $multiValueToggle = $importTargetContent.children("#multiValueToggle").bootstrapToggle({
                        height: 30,
                        on: 'JSON',
                        off: 'PIPE'
                    });
                    $multiValueToggle.focus().select();
                    $multiValueToggle.change(function () {
                        if ($multiValueToggle[0].checked) {
                            multiValueFormat = "JSON";
                        } else {
                            multiValueFormat = "PIPE";
                        }
                    });

                    Utils.$("#submit-files")
                        .unbind()
                        .on("click", () => {
                            const file = Utils.$("#choose-files").prop("files")[0];
                            if(file) {
                                ActionSpinner.get(`/type/${this.props.currentBusinessObject.id}`, {}, {key: "getResourceType", showOnError: true},false)
                                    .then(response => {
                                        if (response) {
                                            importV2(file,multiValueFormat, response.data.boKey)
                                                .then(response => {
                                                    submit(response.data.importId)
                                                        .then(() => {
                                                            const aTarget = `<a class="link" onclick="window.open(\'${process.env.ENV_PREFIX}/instance/${response.data.failedRowsAttachmentId}\')">
                                                                                    <span style="font-size: 15px;">
                                                                                        Click here to view the failed rows.
                                                                                    </span>
                                                                                </a>`

                                                            Utils.$('.qtip-dark').remove();
                                                            Utils.$(e.target).qtip('destroy');
                                                            this.onFilterTextBoxChanged({type: "click"})
                                                            if (response.data.failedRows && response.data.failedRows.length >= 1 && response.data.instances.length === 0) {
                                                                const msg = `<div>
                                                                                 <p style="font-size: 15px;">Data import failed.</p>
                                                                                 ${aTarget}
                                                                            </div>`
                                                                toastr.error(`${msg}`, response.data.message, {
                                                                    timeOut: 10000,
                                                                    extendedTimeOut: 5000,
                                                                    tapToDismiss: false
                                                                });
                                                            } else if (response.data.failedRows && response.data.failedRows.length >= 1 && response.data.instances.length >= 1) {
                                                                const msg = `<div>
                                                                                 <p style="font-size: 15px;">Data import finished, but some of the rows contain wrong data.</p>
                                                                                  ${aTarget}
                                                                            </div>`
                                                                toastr.warning(`${msg}`, response.data.message, {
                                                                    timeOut: 10000,
                                                                    extendedTimeOut: 5000,
                                                                    tapToDismiss: false
                                                                });
                                                            } else if (!response.data.failedRows && response.data.instances.length >= 1) {
                                                                toastr.success('Data import finished successfully.')
                                                            }
                                                        })
                                                        .catch(() => {
                                                            Utils.$('.qtip-dark').remove();
                                                            Utils.$(e.target).qtip('destroy');
                                                        })
                                                })
                                                .catch(() => {
                                                    Utils.$('.qtip-dark').remove();
                                                    Utils.$(e.target).qtip('destroy');
                                                })
                                        }
                                    })
                                    .catch(() => {
                                        Utils.$('.qtip-dark').remove();
                                        Utils.$(e.target).qtip('destroy');
                                    })
                            } else {
                                toastr.warning("Please attach a file first.")
                            }
                        })

                    Utils.$("#qtipContainerImport")
                        .unbind()
                        .on("keydown", (evt) => {
                            if (evt.keyCode === 27) {
                                Utils.$(".qtip").remove();
                            }
                        });

                }
            },
            position: {
                my: 'top right',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-dark',
                width: 350
            }
        });
    };

    onOpenExportDialog = (e) => {
        const $exportTargetContent = this.state.$exportTargetContentModel.clone();
        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Manage Data Exports"
                },
                text: $exportTargetContent,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            events: {
                show: () => {
                    $(e.target).css("background-color", "#676A6C");
                },
                hide: () => {
                    Utils.$(e.target).css("background-color", "#1AB394");
                    Utils.$('.qtip-dark').remove();
                    Utils.$(e.target).qtip('destroy');
                },
                visible: () => {
                    document.getElementById("tsv-btn").focus();
                },
                render: () => {
                    let multiValueFormat = "PIPE";
                    let dataView = "Current View Columns";

                    let $multiValueToggle = $exportTargetContent.children("#multiValueToggle").bootstrapToggle({
                        height: 30,
                        on: 'JSON',
                        off: 'PIPE'
                    });
                    $multiValueToggle.focus().select();
                    $multiValueToggle.change(() => {
                        if ($multiValueToggle[0].checked) {
                            multiValueFormat = "JSON";
                        } else {
                            multiValueFormat = "PIPE";
                        }
                    });
                    let $dataViewToggle = $exportTargetContent.children("#dataViewToggle").bootstrapToggle({
                        height: 30,
                        on: 'Full View Columns',
                        off: 'Current View Columns'
                    });
                    $dataViewToggle.focus().select();
                    $dataViewToggle.change(() => {
                        if ($dataViewToggle[0].checked) {
                            dataView = "Full View Columns";
                        } else {
                            dataView = "Current View Columns";
                        }
                    });

                    Utils.$("#tsv-btn")
                        .unbind()
                        .click(() => {
                            this.closeBurgerMenu()
                            manageDataExport(this.props.currentBusinessObject, dataView === "Current View Columns" ?
                                this.props.currentDataView.viewName : "full", "TSV",  this.lastExecutedQuery.filter, multiValueFormat, this.lastExecutedQuery.searchText, this.lastExecutedQuery.sort)
                                .then(response => {
                                    FileSaver.saveAs(response.data, `${this.props.currentBusinessObject.name}_TSV_EXPORT.tsv`);
                                    Utils.$(".qtip").remove();
                                })

                        });

                    Utils.$("#xlsx-btn")
                        .unbind()
                        .click(() => {
                            this.closeBurgerMenu()
                            manageDataExport(this.props.currentBusinessObject, dataView === "Current View Columns" ?
                                this.props.currentDataView.viewName : "full", "EXCEL", this.lastExecutedQuery.filter, multiValueFormat, this.lastExecutedQuery.searchText, this.lastExecutedQuery.sort)
                                .then(response => {
                                    FileSaver.saveAs(response.data, `${this.props.currentBusinessObject.name}_EXCEL_EXPORT.xlsx`);
                                    Utils.$(".qtip").remove();
                                })
                        });

                    Utils.$("#json-btn")
                        .unbind()
                        .click(() => {
                            this.closeBurgerMenu()
                            manageDataExport(this.props.currentBusinessObject, dataView === "Current View Columns" ?
                                this.props.currentDataView.viewName : "full", "JSON", this.lastExecutedQuery.filter, multiValueFormat, this.lastExecutedQuery.searchText, this.lastExecutedQuery.sort)
                                .then(response => {
                                    FileSaver.saveAs(response.data, `${this.props.currentBusinessObject.name}_JSON_EXPORT.json`);
                                    Utils.$(".qtip").remove();
                                })
                        });
                    Utils.$("#qtipContainerExport")
                        .unbind()
                        .on("keydown", (evt) => {

                            if (evt.keyCode === 27) {
                                Utils.$(".qtip").remove();
                                document.getElementById("save-instance-btn").focus();
                            }
                        });
                }
            },
            position: {
                my: 'top right',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-dark',
                width: 350
            }
        });
    };

    onQuickFilterKeyDown = (e) =>{
        if (e.keyCode === 9) {
            e.preventDefault();

            // scrolls to the first row
            this.state.grid.gridOptions.api.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.grid.gridOptions.columnApi.getAllDisplayedColumns()[0];
            this.state.grid.gridOptions.api.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.grid.gridOptions.api.setFocusedCell(0, currentCol);
        }
    }

    onFilterTextBoxChanged = (e) => {
        let filterModelLength = Object.keys(this.state.grid.gridOptions.api.getFilterModel()).length
        filterModelLength === 0 ? prevInputValuesCounter = 0 : null
        !!e.target.value && filterModelLength > 0 ? prevInputValuesCounter = 1 : null
        if (((e.type === "keyup" && e.keyCode === 13) || e.type === "click") && $(this.refs.quickFilterBox).val() !== '') {
            this.state.grid.gridOptions.api.setFilterModel({
                quickFilter: {
                    filterType: "text",
                    type: "contains",
                    filter: $(this.refs.quickFilterBox).val()
                }
            });
        }
        if (e.keyCode === 8 && $(this.refs.quickFilterBox).val() === '') {
            if (Object.keys(this.state.grid.gridOptions.api.getFilterModel()).length > 0 && prevInputValuesCounter > 0) {
                this.state.grid.gridOptions.api.setFilterModel(null);
            }
        }
        if (e.keyCode === 9) {
            e.preventDefault();

            // scrolls to the first row
            this.state.grid.gridOptions.api.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.grid.gridOptions.columnApi.getAllDisplayedColumns()[0];
            this.state.grid.gridOptions.api.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.grid.gridOptions.api.setFocusedCell(0, currentCol);
        }
    };

    build = (businessObject: BusinessObjectBaseInterface, currentDataView: any, isInplaceEditOperation?: boolean, isDataViewChanged?: boolean) => {
        this.isInitialBuild = true;
        const isInferenceTemp = businessObject.inferenceTemp;
        let attrNameKeyMap: Map<string, string>;
        if (isInferenceTemp) {
            attrNameKeyMap = this.constructAttrNameKeyMap(currentDataView);
            this.setState({
                isInferenceTemp
            });
        }

        const columnDef: any[] = [{
            field: "quickFilter",
            hide: true,
            lockVisible: true,
            filterParams: {
                newRowsAction: "keep"
            },
            dataType: AttributeTypeEnum.TEXT
        }];

        let nameColumnDef = null;

        currentDataView.columns.forEach(item => {
            switch (item.type) {
                case "attribute":
                    if (currentDataView.viewName === 'full' && item.value.name === 'Name' &&
                        item.columnOrder !== 2) {
                        nameColumnDef = {
                            headerName: item.value.name,
                            field: item.value.key,
                            width: 50,
                            dataType: item.value.type,
                            headerTooltip: item.value.name,
                            attributeId: item.value.id,
                            editable: this.state.inplaceEditEnabled,
                            onCellValueChanged: params => updateCellValue(params),
                        }
                    } else {
                        if (isInferenceTemp && item.value.key == "mismatchValuesDefinition" && item.value.type == "json") {
                            break;
                        }
                        let def: any = {
                            headerName: item.value.name,
                            field: item.value.key,
                            width: 50,
                            dataType: item.value.type,
                            headerTooltip: item.value.name,
                            attributeId: item.value.id,
                            editable: this.state.inplaceEditEnabled,
                            cellEditorSelector: () => {
                                if (item.value.type === AttributeTypeEnum.BOOLEAN) {
                                    const values = ['true', 'false'];
                                    if (!item.value.required) {
                                        values.unshift('n/a');
                                    }
                                    return {
                                        component: 'agRichSelect',
                                        params: { values }
                                    };
                                }
                                return { component: 'agManageDataAttributes' };
                            },
                            cellClassRules: {
                                'inference-mismatch-grid-cell-attr': (params) => {
                                    const mismatchAttrDef = Utils.getInferenceMismatchDefinition(params, isInferenceTemp);
                                    return this.isInferenceCellMismatch(params, mismatchAttrDef, attrNameKeyMap);
                                },
                                'inference-mismatch-grid-cell-text-attr': (params) => {
                                    const mismatchAttrDef = Utils.getInferenceMismatchDefinition(params, isInferenceTemp);
                                    return this.isInferenceTextCellMismatch(mismatchAttrDef);
                                }
                            },
                            onCellValueChanged: params => updateCellValue(params),
                            cellRenderer: (params) => {
                                if (!params.node.group) {
                                    if (params.colDef.dataType === AttributeTypeEnum.INT || params.colDef.dataType === AttributeTypeEnum.DECIMAL) {
                                        return `<span>${Utils.numberFormatByLocale(params.value, this.props.locale.value)}</span>`;
                                    }
                                    if (params.colDef.dataType === AttributeTypeEnum.LOOKUP) {
                                        const field = params.colDef.field;
                                        return `<span>${params.data[field] ? params.data[field].value || JSON.parse(params.data[field]).value : ''}</span>`;
                                    }
                                    if (params.colDef.dataType === AttributeTypeEnum.EMAIL) {
                                        return `<span>${params.value ? Utils.parseEmailAttributeValue(params.value) : ''}</span>`;
                                    }
                                    const mismatchAttrDef = Utils.getInferenceMismatchDefinition(params, isInferenceTemp);
                                    if (this.isInferenceCellMismatch(params, mismatchAttrDef, attrNameKeyMap) && mismatchAttrDef.informativeMessage) {
                                        return `<span title="${mismatchAttrDef.informativeMessage}">${params.value}</span>`
                                    }
                                    return `<span>${params.value}</span>`
                                }
                            }
                        };
                        let cellEditorData = _.cloneDeep(item.value);
                        // Removing 'id', 'name' and 'type' column attributes to prevent attribute overlap in updateCellValue function
                        delete cellEditorData.id;
                        delete cellEditorData.name;
                        delete cellEditorData.type;

                        if (item.value.type === AttributeTypeEnum.VALUE_LIST || item.value.type === AttributeTypeEnum.EMAIL) {
                            // Different custom cellEditor is used, in order to apply attrVals parameter instead of attributeValues parameter
                            def['attrVals'] = _.cloneDeep(cellEditorData.attributeValues);
                            def['cellEditorParams'] = {
                                data: JSON.parse(JSON.stringify(cellEditorData)),
                                isPopup: true
                            };
                        } else if (item.value.type !== AttributeTypeEnum.DATE) {
                            def['cellEditorParams'] = {
                                data: JSON.parse(JSON.stringify(cellEditorData)),
                                isPopup: false
                            };
                        }
                        columnDef.push(def);
                    }
                    break;
                case "tags":
                    columnDef.push({
                        headerName: item.value.name,
                        field: camelcase(item.value.name.toLowerCase()),
                        width: 50,
                        cellRenderer: "tagCellRender",
                        dataType: AttributeTypeEnum.TAGS,
                        headerTooltip: item.value.name,
                        editable: true
                    });
                    break;
            }
        });

        const updateCellValue = (params) => {
            let attrObj = {};
            switch (params.colDef.dataType) {
                case AttributeTypeEnum.VALUE_LIST:
                    if (!_.isEqual(_.sortBy(params.newValue), _.sortBy(params.oldValue))) {
                        let attribIds = [];
                        params.newValue.forEach(val => {
                            const foundAttribute = params.data.attributeValues.find(attr => {
                                return attr.name === val;
                            });
                            if (foundAttribute) {
                                attribIds.push(foundAttribute.id)
                            }
                        });
                        attrObj[params.colDef.attributeId] = attribIds;
                    }
                    break;
                case AttributeTypeEnum.LOOKUP:
                    this.lookupUpdateParams = _.cloneDeep(params);
                    break;
                case AttributeTypeEnum.DECIMAL:
                    if (!_.isEqual(parseFloat(params.newValue), parseFloat(params.oldValue))) {
                        attrObj[params.colDef.attributeId] = params.newValue;
                    }
                    break;
                case AttributeTypeEnum.INT:
                    if (!_.isEqual(parseInt(params.newValue), parseInt(params.oldValue))) {
                        attrObj[params.colDef.attributeId] = params.newValue;
                    }
                    break;
                case AttributeTypeEnum.EMAIL:
                    if (!_.isEqual(_.sortBy(Utils.parseEmailAttributeValue(params.newValue)), _.sortBy(Utils.parseEmailAttributeValue(params.oldValue)))) {
                        attrObj[params.colDef.attributeId] = Utils.parseEmailAttributeValue(params.newValue);
                    }
                    break;
                default:
                    if (params.oldValue !== params.newValue) {
                        attrObj[params.colDef.attributeId] = params.newValue;
                    }
            }

            if (Object.keys(attrObj).length > 0) {
                let dto = {
                    attributes: attrObj
                };
                updateInstance(params.data.id, "full", dto)
                    .then((response: any) => {
                        params.node.data.updated = Utils.moment(response.data.updated, Utils.moment.ISO_8601).isValid() ?
                            Utils.utcToLocalDate(response.data.updated) :
                            response.data.updated;
                        params.api.refreshCells();
                        params.api.redrawRows();
                    })
                    .catch((e) => {
                        params.node.data[params.column.colId] = params.oldValue;
                        params.api.refreshCells();
                        params.api.redrawRows();
                    });
            }
        }

        columnDef.push({
            headerName: "Updated", width: 50, field: "updated",
            dataType: AttributeTypeEnum.TIMESTAMP,
            headerTooltip: "Updated",
            sort: "desc",
            editable: true
        });

        if (currentDataView.viewName === 'full' && nameColumnDef) {
            // Always show 'Name' column as second column of the full view regardless of the data view order
            columnDef.unshift(nameColumnDef);
        }

        if (this.props.currentBusinessObject.name.toLowerCase() !== Utils.SysRuleEngineRules &&
            this.props.currentBusinessObject.name.toLowerCase() !== Utils.SysRuleEngineActions) {
            columnDef.unshift({
                headerName: "Merge Into",
                width: 50,
                field: undefined,
                sortable: false,
                colId: 'merge',
                cellRenderer: function (params) {
                    return `<input class="merge-into-radio" style="width: 18px; height: 18px" type="radio" name="merge_into">`
                },
                dataType: AttributeTypeEnum.INT
            });
        }

        columnDef.unshift({
            headerName: "ID", width: 50, field: "id", checkboxSelection: true,
            dataType: AttributeTypeEnum.INT,
            cellRenderer: function (params) {
                return `<label style="cursor: pointer; color: #5baeff">${params.value}</label>`
            },
            headerTooltip: "ID",
            headerComponent: AgSelectAllHeader
        });

        if (isInferenceTemp) {
            columnDef.push({
                headerName: "",
                field: "transfer-action",
                colId: "actions",
                cellRenderer: (params) => {
                    const eButton = document.createElement('button');
                    eButton.id = "transfer-record-row-" + params.rowIndex;
                    eButton.className = "inference-record-transfer-button";
                    eButton.innerHTML = `<span>Transfer Record</span>`;
                    eButton.addEventListener('click', (event) => {
                        this.transferRecord(params, attrNameKeyMap, currentDataView)
                    });
                    if (!this.allMismatchCellsCorrected(params.data, attrNameKeyMap)) {
                        eButton.disabled = true;
                        eButton.className = "inference-record-transfer-button-disabled";
                    }
                    return eButton;
                },
                editable: true,
                filter: false,
                width: 120,
                suppressSizeToFit: true
            });
        }

        function TagCellRender() {
        }

        TagCellRender.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            const $div = $("<div/>");
            const $content = $('<div style="display: -webkit-box"/>');
            const tags = params.value ? params.value : [];
            $(`<button class='btn slick-grid-tags manage-data-qtip-tags'>...</button>`).appendTo($content);
            for (let i = 0; i < Math.min(4, tags.length); i++) {
                $(`<div class="slick-grid-tags" >${tags[i]}</div>`).appendTo($content);
            }
            $content.appendTo($div);
            this.eGui.innerHTML = $div.html();
        };

        TagCellRender.prototype.getGui = function () {
            return this.eGui;
        };

        const gridOptions: any = {
            defaultColDef: {
                resizable: true,
                sortable: true,
                filter: "agTextColumnFilter",
                tooltipComponent: AgHelpToolTip,
                filterParams: {
                    filterOptions: ['contains'],
                    applyButton: true,
                    clearButton: true,
                    suppressAndOrCondition: true
                },
                headerComponentParams: {
                    template: helpHeaderTemplate
                },
                onCellClicked: (props) => {
                    if (props.column.colId === "id") {
                        this.saveGridState();
                        switch (this.props.currentBusinessObject.name.toLowerCase()) {
                            case Utils.SysRuleEngineRules:
                                history.push({
                                    pathname: `${process.env.ENV_PREFIX}/rules/${props.value}`,
                                    state: {
                                        bocId: this.props.currentBusinessObject.id,
                                        instanceId: props.value
                                    }
                                });
                                break;
                            case Utils.SysRuleEngineActions:
                                history.push({
                                    pathname: `${process.env.ENV_PREFIX}/actions/${props.value}`,
                                    state: {
                                        bocId: this.props.currentBusinessObject.id,
                                        instanceId: props.value
                                    }
                                });
                                break;
                            default:
                                history.push(`${process.env.ENV_PREFIX}/instance/${props.value}`);
                        }
                    }
                    if (props.column.colId === "merge") {
                        this.setState({margeIntoId: props.data.id});
                    }
                },
                floatingFilterComponentParams: {suppressFilterButton: true},
                menuTabs: ['generalMenuTab']
            },
            tabToNextCell: (params) => {
                const previousCell = params.previousCellPosition;
                const nextCell = params.nextCellPosition;
                return {
                    rowIndex: previousCell.rowIndex,
                    column: nextCell.column,
                    floating: previousCell.floating,
                };
            },
            onCellEditingStarted: (params) => {
                if (params.colDef.dataType === AttributeTypeEnum.LOOKUP) {
                    params.api.stopEditing();
                    let businessObjects = _.cloneDeep(this.props.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY));
                    businessObjects.forEach(bo => {
                        let attributesArray = [];
                        let attributesKeys = Array.from(bo.attributes.keys());
                        attributesKeys.forEach((key: any) => {
                            attributesArray.push(bo.attributes.get(key));
                        })
                        // Exchanging map with array of map values
                        bo.attributes = attributesArray;
                    })
                    params.data['value'] = params.value;
                    // @ts-ignore
                    this.lookupInstanceModalRef.current.show(params.data, businessObjects);
                }
                if (params.colDef.field === "updated" || params.colDef.dataType === AttributeTypeEnum.TAGS || params.colDef.field === "transfer-action") {
                    params.api.stopEditing();
                    if (params.colDef.field === "transfer-action") {
                        document.getElementById("transfer-record-row-" + params.rowIndex).click();
                    }
                }
            },
            components: {
                tagCellRender: TagCellRender,
                agInstanceAttributes: getAttributesEditor(),
                agManageDataAttributes: getManageDataEditor()
            },
            cacheQuickFilter: this.refs.quickFilterBox,
            onCellClicked: (params) => {
                if ($(params.event.target).hasClass("manage-data-qtip-tags")) {
                    const item = params.data;
                    AgGridTagsQtip({
                        item,
                        gridOptions,
                        target: params.event.target,
                        rowNode: params.node,
                        viewportId: "ManageDataGrid",
                        tagsList: Array.from(this.props.tagsSet),
                        saveTags: (oldTags, tagsForSave) => {
                            const currentInstance = new Instance(item.id, item.name, {
                                id: null,
                                name: null,
                                description: null
                            }, [], [], item.tags, "", Utils.moment.utc(item.updated).utcOffset(Utils.moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), "");

                            const originalInstance = new Instance(item.id, item.name, {
                                id: null,
                                name: null,
                                description: null
                            }, [], [], oldTags, "", Utils.moment.utc(item.updated).utcOffset(Utils.moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), "");

                            this.props.addBOInstanceTags(currentInstance, originalInstance, tagsForSave);
                        },
                        deleteTags: (oldTags, tagsForDelete) => {
                            const currentInstance = new Instance(item.id, item.name, {
                                id: null,
                                name: null,
                                description: null
                            }, [], [], item.tags, "", Utils.moment.utc(item.updated).utcOffset(Utils.moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), "");

                            const originalInstance = new Instance(item.id, item.name, {
                                id: null,
                                name: null,
                                description: null
                            }, [], [], oldTags, "", Utils.moment.utc(item.updated).utcOffset(Utils.moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), "");

                            this.props.deleteBOInstanceTags(currentInstance, originalInstance, tagsForDelete);
                        },
                    });
                }
            },
            onGridReady: (params: any) => {
                params.api.redrawRows();
                params.api.sizeColumnsToFit();
            },
            onRowSelected: (params: any) => {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    if (this._isMounted) {
                        this.state.grid.gridOptions.selectAllHeader.onRowSelected(params);
                        this.forceUpdate();
                    }
                }, 1);
            },
            onFilterChanged: () => {AgGridUtils.deselectAllRows(this.state.grid.gridOptions.api)},
            suppressPropertyNamesCheck: true,
            suppressRowClickSelection: true,
            suppressDragLeaveHidesColumns: true,
            columnDefs: columnDef,
            enableCellTextSelection: true,
            ensureDomOrder: true,
            floatingFilter: true,
            rowSelection: 'multiple',
            rowModelType: 'serverSide',
            cacheBlockSize: 100,
            maxBlocksInCache: 500,
            maxConcurrentDatasourceRequests: 2,
            animateRows: true,
            debug: false
        };

        const grid = new agGrid.Grid((this.refs.gridRef as HTMLElement), gridOptions);
        if (localStorage.getItem('cameFromInstance') || isInplaceEditOperation || this.props.selectedSearch) {
            this.isInitialBuild = false;
        }
        if (localStorage.getItem('cameFromInstance')) {
            localStorage.removeItem('cameFromInstance');
            if (this.props.selectedSearch) {
                // By this we provide filter preservation and 'back to list' functionality
                this.props.handleSelectedSearch(this.props.selectedSearch);
            } else {
                this.restoreGridState(gridOptions)
            }
        }
        if (this.props.selectedSearch) {
            let filterModel: any = {};
            let sortModel: any[] = [];
            const {search} = this.props.selectedSearch.data;

            Object.keys(JSON.parse(search.filter)).forEach(key => {
                filterModel[key] = {
                    filterType: "text",
                    type: "contains",
                    filter: JSON.parse(search.filter)[key]
                }
            })
            if (search.searchText !== '') {
                filterModel['quickFilter'] = {
                    filterType: "text",
                    type: "contains",
                    filter: search.searchText
                }
                $(this.refs.quickFilterBox).val(search.searchText);
            } else {
                $(this.refs.quickFilterBox).val('');
            }

            Object.keys(JSON.parse(search.sort)).forEach(key => {
                sortModel.push({
                    colId: key,
                    sort: JSON.parse(search.sort)[key]
                })
            })

            gridOptions.api.setFilterModel(filterModel);
            gridOptions.api.setSortModel(sortModel);
        }
        gridOptions.api.setServerSideDatasource(this.ServerSideDatasource(businessObject.id, isInplaceEditOperation));
        if (isDataViewChanged) {
            this.restoreGridState(gridOptions)
        }
        if (isInplaceEditOperation) {
            this.restoreGridState(gridOptions)
        }
        this.setState({grid}, () => {
            Utils.$(".ag-floating-filter-input").each(function (index) {
                Utils.$(this).attr('id', 'manageData-search-filter-' + index);
            });
        });
        $("#hide-nav-btn").on("click", function () {
            setTimeout(() => {
                gridOptions.api.sizeColumnsToFit();
            }, 500);
        });

    };

    constructAttrNameKeyMap = (dataView: any): Map<string, string> => {
        const attrNameKeyMap: Map<string, string> = new Map();
        for (let column of dataView.columns) {
            if (column.type == "attribute") {
                attrNameKeyMap.set(column.value.name, column.value.key);
            }
        }
        return attrNameKeyMap;
    };

    isInferenceCellMismatch = (params, mismatchAttr, attrNameKeyMap) => {
        if (!mismatchAttr) {
            return false;
        }
        return !this.isMismatchCellCorrected(params.data, mismatchAttr, attrNameKeyMap);
    };

    isInferenceTextCellMismatch = (mismatchAttr) => {
        if (!mismatchAttr) {
            return false;
        }
        return mismatchAttr.targetAttributeType === AttributeTypeEnum.TEXT;
    };

    transferRecord = (params, attrNameKeyMap: Map<string, string>, currentDataView: any) => {
        const mismatchAttributes = Utils.retrieveMismatchAttributes(params.data);
        if (!mismatchAttributes) {
            toastr.error("Unable to transfer. Invalid mistmatch attribute values definition for selected record.");
            return;
        }
        let correctedAttributes = {};
        for (let mismatchAttr of mismatchAttributes) {
            if (!attrNameKeyMap.has(mismatchAttr.columnName)) {
                toastr.error("smth wen wrong- cannot transfer");
                return;
            }
            const attrKey = attrNameKeyMap.get(mismatchAttr.columnName);
            correctedAttributes[attrKey] = params.data[attrKey];
        }
        const instanceToTransfer = [{
                "attributes": correctedAttributes,
                "instanceId": params.data.id
        }];
        transferInferenceMismatchRecords(instanceToTransfer)
            .then(response => {
                if (response.data.mismatchTypeDeleted) {
                    // no records for transfer left
                    this.props.onBusinessObjectChange({
                        value: response.data.typeInfo.id,
                        label: response.data.typeInfo.name
                    });
                } else {
                    params.api.onFilterChanged();
                }
            })
            .catch(error => {
                toastr.error(error.response.data.message);
            });
    };

    allMismatchCellsCorrected = (attributeData: any, attrNameKeyMap: Map<string, string>): boolean => {
        const mismatchAttributes = Utils.retrieveMismatchAttributes(attributeData);
        if (!mismatchAttributes) {
            return true;
        }
        for (let mismatchAttr of mismatchAttributes) {
            if (!this.isMismatchCellCorrected(attributeData, mismatchAttr, attrNameKeyMap)) {
                return false;
            }
        }
        return true;
    };

    isMismatchCellCorrected = (attributeData: any, mismatchAttr: any, attrNameKeyMap: Map<string, string>): boolean => {
        const columnName = mismatchAttr.columnName;
        if (!attrNameKeyMap.has(columnName)) {
            return false;
        }
        const attrKey = attrNameKeyMap.get(columnName);
        const attrVal = attributeData[attrKey];
        if (!attrVal) {
            return false;
        }
        switch (mismatchAttr.targetAttributeType) {
            case AttributeTypeEnum.TEXT: {
                return true;
            }
            case AttributeTypeEnum.DECIMAL: {
                if (Number.isNaN(parseFloat(attrVal))) {
                    return false;
                }
                break;
            }
            case AttributeTypeEnum.DATE: {
                if (!Utils.isValidDate(attrVal.toString())) {
                    return false;
                }
                break;
            }
            case AttributeTypeEnum.TIME: {
                if (!Utils.isFullRegexMatchPresent(attrVal.toString(), /(\d{2}):(\d{2}):(\d{2})/g)) {
                    return false;
                }
                break;
            }
            case AttributeTypeEnum.TIMESTAMP: {
                if (!Utils.isFullRegexMatchPresent(attrVal.toString(), /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/g)) {
                    return false;
                }
                break;
            }
            case AttributeTypeEnum.INT: {
                if (!Utils.isFullRegexMatchPresent(attrVal.toString(), /-?\d+/g)) {
                    return false;
                }
                break;
            }
            case AttributeTypeEnum.JSON: {
                try {
                    JSON.parse(attrVal);
                } catch(e) {
                    return false;
                }
                break;
            }
            default: {
                return false;
            }
        }
        return true;
    };

    onMerge = () => {
        const instancesIds = this.state.grid.gridOptions.api.getSelectedRows().map((item: any) => item.id);
        Utils.$('#merge-instance-btn').blur();

        if (instancesIds.length >= 2 && this.state.margeIntoId !== -1) {
            const $mergeRelationships = this.state.$mergeRecordsContent.clone();

            let $multiValueToggle = $mergeRelationships.children("#multiValueToggle").bootstrapToggle({
                height: 30,
                on: 'NO',
                off: 'YES'
            });

            $multiValueToggle.focus().select();
            $multiValueToggle.change(() => {
                if ($multiValueToggle[0].checked) {
                    this.setState({
                        mergeRelationships: true
                    })
                } else {
                    this.setState({
                        mergeRelationships: false
                    })
                }
            });

            Utils.$.confirm({
                title: `You are about to merge ${instancesIds.length} records`,
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: $mergeRelationships,
                type: 'orange',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Merge!",
                        btnClass: 'btn-warning',
                        keys: ['enter'],
                        action: () => {
                            const dto = {
                                mergeRelationships: !this.state.mergeRelationships,
                                mergeToRecordId: this.state.margeIntoId,
                                recordIds: instancesIds
                            };
                            this.closeBurgerMenu()
                            ActionSpinner.get(`/type/${this.props.currentBusinessObject.id}`, {}, {key: "getResourceType", showOnError: true}, false)
                                .then(response => {
                                    if (response) {
                                        mergeInstances(dto, response.data.boKey)
                                            .then(() => {
                                                toastr.success("Instances merged successfully.");
                                                this.state.grid.gridOptions.api.deselectAll();
                                                this.state.grid.gridOptions.api.onFilterChanged();
                                            })
                                    }
                                })
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        } else {
            toastr.warning("Please select at least two records and one record to merge into.")
        }
    };

    onClone = (e) => {
        const instancesIds = this.state.grid.gridOptions.api.getSelectedRows().map((item: any) => item.id);
        const grid = this.state.grid;
        if (instancesIds.length > 0) {
            const $cloneTargetContent = this.state.$cloneTargetContentModel.clone();
            const BOid = this.props.currentBusinessObject.id;
            Utils.$(e.target).qtip({
                content: {
                    title: function () {
                        return "Manage Data Cloning"
                    },
                    text: $cloneTargetContent,
                    button: "Close"
                },
                show: true,
                hide: "unfocus",
                events: {
                    show: () => {
                        $(e.target).css("background-color", "#676A6C");
                    },
                    hide: () => {
                        Utils.$(e.target).css("background-color", "#1AB394");
                        Utils.$('.qtip-dark').remove();
                        Utils.$(e.target).qtip('destroy');
                    },
                    visible: () => {
                        document.getElementById("numberOfCopies").focus();
                    },
                    render: () => {
                        let includeRelationships = "No";
                        let cloneRelatedInstances = "No";
                        let shareClonedInstances = "No";
                        let $cloneRelsToggle = $cloneTargetContent.children("#cloneRelsToggle").bootstrapToggle({
                            height: 30,
                            on: 'Yes',
                            off: 'No'
                        });

                        let $cloneRelatedInstances = $cloneTargetContent.children("#cloneRelatedInstances").bootstrapToggle({
                            height: 30,
                            on: 'Yes',
                            off: 'No'
                        });

                        let $shareClonedInstances = $cloneTargetContent.children("#shareClonedInstances").bootstrapToggle({
                            height: 30,
                            on: 'Yes',
                            off: 'No'
                        });

                        // Clone relationships handler
                        $cloneRelsToggle.focus().select();
                        $cloneRelsToggle.change(function () {
                            if ($cloneRelsToggle[0].checked ) {
                               includeRelationships = "Yes";
                                $cloneRelatedInstances.bootstrapToggle('enable');
                                $shareClonedInstances.bootstrapToggle('enable');
                               } else {
                                includeRelationships = "No";
                                cloneRelatedInstances = "No";
                                shareClonedInstances = "No";
                                Utils.$("#cloneRelatedInstances").parent().removeClass('btn-primary').addClass('btn-danger off')
                                $cloneRelatedInstances[0].checked = false
                                Utils.$("#shareClonedInstances").parent().removeClass('btn-primary').addClass('btn-danger off')
                                $shareClonedInstances[0].checked = false
                                $cloneRelatedInstances.bootstrapToggle('disable');
                                $shareClonedInstances.bootstrapToggle('disable');
                            }
                        });

                        //Clone Related Instances handler
                        $cloneRelatedInstances.focus().select();
                        $cloneRelatedInstances.change(function () {
                            $cloneRelatedInstances.bootstrapToggle('enable');
                            if ($cloneRelatedInstances[0].checked) {
                                cloneRelatedInstances = "Yes";
                            } else {
                                cloneRelatedInstances = "No";
                            }
                        });
                        // Share Cloned Instances handler
                        $shareClonedInstances.focus().select();
                        $shareClonedInstances.change(function () {
                            if ($shareClonedInstances[0].checked) {
                                shareClonedInstances = "Yes";
                            } else {
                                shareClonedInstances = "No";
                            }
                        });
                        Utils.$("#cloneRelsToggle").parent(".toggle")[0].title = 'CTRL + LEFT_ARROW or RIGHT_ARROW';
                        const submitClone = () => {
                            const warningMessage = 'Please enter an integer in the range from 1 to 999';
                            const numberOfCopies = parseFloat(Utils.$("#numberOfCopies")[0].value);
                            if (Number.isInteger(numberOfCopies) && numberOfCopies > 0 && numberOfCopies <= 999) {
                                Utils.$(".qtip").remove();
                                const dto = {
                                    "cloneRelatedInstances": cloneRelatedInstances === 'Yes',
                                    "copiesCount": numberOfCopies,
                                    "includeRelationships": includeRelationships === "Yes",
                                    "recordIds": instancesIds,
                                    "shareClonedRelatedInstances": shareClonedInstances === 'Yes'
                                };
                                this.closeBurgerMenu()
                                ActionSpinner.get(`/type/${BOid}`, {}, {
                                    key: "getResourceType",
                                    showOnError: true
                                }, false)
                                    .then(response => {
                                        if (response) {
                                            cloneBoInstance(response.data.boKey, dto)
                                                .then(() => {
                                                    toastr.success('Clone instances passed successfully');
                                                    grid.gridOptions.api.deselectAll();
                                                    grid.gridOptions.api.onFilterChanged();
                                                });
                                        }
                                    })
                            } else {
                                toastr.warning(warningMessage);
                            }
                        }

                        Utils.$("#submitCopies")
                            .unbind()
                            .on("click", () => {
                                if (Utils.$("#numberOfCopies")[0] && Utils.$("#numberOfCopies")[0].value) {
                                    submitClone();
                                }
                            });
                        Utils.$("#numberOfCopies")
                            .unbind()
                            .on("keydown", (evt) => {
                                /* On enter key down */
                                if (evt.keyCode === 13 && Utils.$("#numberOfCopies")[0] && Utils.$("#numberOfCopies")[0].value) {
                                    submitClone();
                                }
                            });
                        Utils.$('#numberOfCopies').on('propertychange input', function (e) {
                            const inputObj = Utils.$("#numberOfCopies")[0];
                            if (parseInt(inputObj.value) > parseInt(inputObj.max)){
                                inputObj.value = inputObj.value.slice(0,3);
                            }
                            if (parseInt(inputObj.value) < parseInt(inputObj.min)){
                                inputObj.value = '1'
                            }
                        });
                        Utils.$("#qtipContainer")
                            .unbind()
                            .on("keydown", (evt) => {
                                /* On arrows key down */
                                if ((evt.ctrlKey && evt.keyCode === 37 || (evt.ctrlKey && evt.keyCode === 39))) {
                                    Utils.$("#cloneRelsToggle").bootstrapToggle('toggle');
                                }
                                /* On escape key down */
                                if (evt.keyCode === 27) {
                                    Utils.$(".qtip").remove();
                                    document.getElementById("save-instance-btn").focus();
                                }
                            });
                    }
                },
                position: {
                    my: 'top right',
                    at: 'bottom center',
                    viewport: $(document.body)
                },
                style: {
                    classes: 'qtip-dark',
                    width: 350
                }
            });
        } else {
            toastr.warning("Please select at least one record.")
        }
    };

    onDownload = () => {
        const ids = this.state.grid.gridOptions.api.getSelectedRows().map((item: any) => item.id);
        if (ids.length > 0) {
            this.props.downloadZip(ids, this.props.currentBusinessObject.name);
        } else {
            toastr.warning('Please select at least one instance');
        }
    };

    ServerSideDatasource = (id: number, isInplaceEditOperation?: boolean) => {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sort = generateSortData(params.request.sortModel, this.isInitialBuild);
                const filter = this.isInitialBuild ? {} : AgGridUtils.generateFilterData(params);
                if (this.isInitialBuild) {
                    this.isInitialBuild = false;
                }
                const currentQuery = {
                    filter: JSON.stringify(filter),
                    searchText: params.request.filterModel.quickFilter ? params.request.filterModel.quickFilter.filter : "",
                    sort: JSON.stringify(sort)
                };

                this.lastExecutedQuery = currentQuery
                this.props.setLastSearch(currentQuery);

                if (currentQuery && this.props.selectedSearch && !_.isEqual(currentQuery, this.props.selectedSearch.data.search)) {
                    // Setting selected saved search to null, because new request has been sent and the user will no longer see results from the applied saved search
                    this.props.setSelectedSearch(null);
                }

                Axios.instance.post(`boi/data/${id}?dataFormat=MAP&dataView=${urlencode(this.props.currentDataView.viewName)}&limit=${limit}&page=${page}`, currentQuery)
                    .then((response: any) => {
                        if (this._isMounted) {
                            const dataArray = response.data.content.map(item => {
                                const base = {
                                    id: item.id,
                                    tags: item.tags,
                                    updated: Utils.moment(item.updated, Utils.moment.ISO_8601).isValid() ? Utils.utcToLocalDate(item.updated) : item.updated
                                };
                                const custom = {};
                                Object.keys(item.data).map((key, index) => {
                                    const dataViewAttr = response.data.dataView.attributes[index];
                                    if (dataViewAttr) {
                                        switch (dataViewAttr.attribute.type) {
                                            case AttributeTypeEnum.TIME:
                                                custom[key] = Utils.utcToLocalTime(item.data[key]);
                                                break;
                                            case AttributeTypeEnum.TIMESTAMP:
                                                custom[key] = Utils.moment(item.data[key], Utils.moment.ISO_8601).isValid() ? Utils.utcToLocalDate(item.data[key]) : item.data[key];
                                                break;
                                            default:
                                                custom[key] = item.data[key];
                                        }
                                    }
                                });
                                return {
                                    ...base,
                                    ...custom
                                }
                            });
                            try {
                                const lastRow = dataArray.length < limit ? params.request.startRow + dataArray.length : -1;
                                this.lastDataArray = [...dataArray];
                                params.successCallback(dataArray, lastRow);
                                this.state.grid.gridOptions.selectAllHeader.update(response.data.totalElements, (limit * (page + 1)) > response.data.totalElements ? response.data.totalElements : (limit * (page + 1)), params.parentNode.gridApi.getSelectedRows().length);
                                if (this.state.grid.gridOptions.selectAllHeader.isSelected()) {
                                    this.state.grid.gridOptions.selectAllHeader.selectAll();
                                }
                                this.forceUpdate();
                            } catch (e) {
                                console.error(e);
                            }
                        }
                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    }

    editRawBtn = (): React.ReactNode => {
        switch (this.props.currentBusinessObject.name.toLowerCase()) {
            case Utils.SysRuleEngineRules:
            case Utils.SysRuleEngineActions:
                return (
                    <button
                        id={'edit-raw-btn'}
                        onClick={this.onEditRawHandler}
                        style={{marginRight: 2, height: 36}}
                        className={"btn btn-new-design"}
                        title={'CTRL + ALT + T'}
                    >
                        <i className="fas fa-edit" /> Edi
                        <strong style={{fontSize: '14px'}} className={'shortcut-btn-letters'}>t</strong> Raw
                    </button>
                );
            default:
                return null
        }
    };

    customImport = (): React.ReactNode => {
        if (this.props.currentBusinessObject.name.toLowerCase() === "specification") {
            return (
                <button onClick={this.onCustomImportHandler.bind(this)}
                        style={{marginRight: 2, height: 36, width: 170, marginBottom: 7}}
                        className="btn" type="button">
                    <i className={"fas fa-upload"} style={{pointerEvents: "none"}}/> <span
                    style={{pointerEvents: "none"}}>Import SpecOptT</span>
                </button>
            );
        } else {
            return null;
        }
    };

    onCustomImportHandler = () => {
        if (this.props.currentBusinessObject.name.toLowerCase() === "specification") {
            this.importSpecModal.open("SpecOptT", () => {
                this.onFilterTextBoxChanged({type: "click"});
            });
        }
    };
    // On Expand button click to expand all columns  
    expandAllColumns = ({ columnApi }) => {
        const { resizeAction } = this.state;
        const allColumnIds = [];
        columnApi.getAllColumns().forEach((column) => {
            allColumnIds.push(column.colId);
        });
        columnApi.autoSizeColumns(allColumnIds, false);

        if (resizeAction !== ResizeActions.FIT_SCREEN) {
            this.setState({ ...this.state, resizeAction: ResizeActions.FIT_SCREEN})
        }
    };
    // On Fit Screen button click
    fitScreenColumns = () => {
        const { resizeAction, grid } = this.state;
        grid.gridOptions.columnApi.resetColumnState();
        grid.gridOptions.api.sizeColumnsToFit();
        if (resizeAction !== ResizeActions.FIT_CONTENT) {
            this.setState({ ...this.state, resizeAction: ResizeActions.FIT_CONTENT})
        }
    };
    // function for handling columns expand and fit screen
    onResizeColumns = () => {
        const { resizeAction, grid } = this.state;
        if (resizeAction === ResizeActions.FIT_SCREEN) {
            this.fitScreenColumns();
        } else {
            this.expandAllColumns(grid.gridOptions);
        }
    };

    onInput = (e) => {
        if (e.currentTarget.value === '' && !e.nativeEvent.inputType) {
            // 'X' button inside the input is pressed
            this.state.grid.gridOptions.api.setFilterModel({
                quickFilter: {
                    filterType: "text",
                    type: "contains",
                    filter: $(this.refs.quickFilterBox).val()
                }
            });
        }
    };

    onInplaceEdit = () => {
        this.setState({
            inplaceEditEnabled: !this.state.inplaceEditEnabled
        }, () => {
            if (this.state.inplaceEditEnabled) {
                document.getElementById("inplace-edit-btn").classList.add('inplace-edit-active');
            } else {
                document.getElementById("inplace-edit-btn").classList.remove('inplace-edit-active');
            }
            if (this.state.grid) {
                this.saveGridState()
                this.state.grid.gridOptions.api.destroy();
                this.build(this.props.currentBusinessObject, this.props.currentDataView, true);
            } else {
                this.build(this.props.currentBusinessObject, this.props.currentDataView, true);
            }
        });
    };

    onSaveLookupAttribute = (data: any) => {
        this.state.grid.gridOptions.api.forEachNode(node => {
            if (node.data.id === data.id) {
                let attrObj = {};
                attrObj[this.lookupUpdateParams.colDef.attributeId] = data.instanceId;
                let dto = {
                    attributes: attrObj
                };
                updateInstance(data.id, "full", dto)
                    .then((response: any) => {
                        node.data[this.lookupUpdateParams.colDef.field] = {
                            id: data.instanceId,
                            value: data.name
                        };
                        node.data.updated = Utils.moment(response.data.updated, Utils.moment.ISO_8601).isValid() ?
                            Utils.utcToLocalDate(response.data.updated) :
                            response.data.updated;
                        this.state.grid.gridOptions.api.refreshCells({ force: true });
                    })
            }
        });
    };

    nextCellForEdit = () => {
        const {api, columnApi} = this.state.grid.gridOptions;
        const currentCell = api.getFocusedCell();
        const displayedCols = columnApi.getAllDisplayedColumns();

        let nextCol = null;
        let nextRowIdx = currentCell.rowIndex;

        displayedCols.forEach((col, idx) => {
            if (col.colId === currentCell.column.colId) {
                if (idx < displayedCols.length - 1) {
                    nextCol = displayedCols[idx+1]
                } else {
                    nextCol = displayedCols[0];
                    nextRowIdx += 1;
                }
            }
        })

        if (nextCol) {
            // scrolls to the next column
            api.ensureColumnVisible(nextCol);
            // sets focus into the grid cell
            api.setFocusedCell(nextRowIdx, nextCol);
            /*api.startEditingCell({
                rowIndex: nextRowIdx,
                colKey: nextCol.colId
            })*/
        }
    };

    onClear = () => {
        if ($(this.refs.quickFilterBox).val() !== '') {
            $(this.refs.quickFilterBox).val('');
        }
        if (Object.keys(this.state.grid.gridOptions.api.getFilterModel()).length > 0) {
            this.state.grid.gridOptions.api.setFilterModel(null);
        }
        if (this.state.grid.gridOptions.api.getSortModel().length > 0) {
            this.state.grid.gridOptions.api.setSortModel([]);
        }
    };

    uploadFileHandler = (e) => {
        const $uploadFile = this.state.$uploadFile.clone();

        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Upload Files"
                },
                text: $uploadFile,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            events: {
                show: () => {
                    $(e.target).css("background-color", "#676A6C");
                },
                hide: () => {
                    Utils.$(e.target).css("background-color", "#1AB394");
                    Utils.$('.qtip-dark').remove();
                    Utils.$(e.target).qtip('destroy');
                },
                visible: () => {
                    document.getElementById("choose-files").focus();
                },
                render: () => {
                    let isPublic = false;
                    let $multiValueToggle = $uploadFile.children("#multiValueToggle").bootstrapToggle({
                        height: 30,
                        on: 'YES',
                        off: 'NO'
                    });
                    $multiValueToggle.focus().select();
                    $multiValueToggle.change(function () {
                        if ($multiValueToggle[0].checked) {
                            isPublic = true;
                        } else {
                            isPublic = false;
                        }
                    });

                    Utils.$("#submit-files")
                        .unbind()
                        .on("click", () => {
                            const files = Utils.$("#choose-files").prop("files");
                            if (files) {
                                const imageUploadRequests: any = [];
                                const keys = Object.keys(files);
                                keys.forEach(fileKey => {
                                    imageUploadRequests.push(uploadFile(files[fileKey], isPublic));
                                })
                                Utils.$('.qtip-dark').remove();
                                Utils.$(e.target).qtip('destroy');
                                uploadFiles(imageUploadRequests)
                                    .catch(() => {
                                        toastr.error('Something went wrong while uploading the selected files')
                                    })
                                    .finally(() => {
                                        this.state.grid.gridOptions.api.onFilterChanged();
                                    })
                            }
                        })

                    Utils.$("#qtipContainerImport")
                        .unbind()
                        .on("keydown", (evt) => {
                            if (evt.keyCode === 27) {
                                Utils.$(".qtip").remove();
                            }
                        });

                }
            },
            position: {
                my: 'top right',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-dark',
                width: 350
            }
        });
    }

    render(): React.ReactNode {
        const hamburgerMenuStyles = {
            bmBurgerButton: {
                height: 30,
                marginTop: 3
            },
            bmBurgerBars: {
                background: '#2D3436'
            },
            bmMenu: {
                backgroundColor: '#7ed6df',
                backgroundImage: 'linear-gradient(180deg, #468188 0%, #1d1b1b 74%)',
                width: 200,
                padding: 10,
                margin: 0
            },
            bmCross: {
                background: '#bdc3c7'
            },
        }

        return (
            <div style={{width: "100%", height: "100%"}}>
                <div style={{height: 42, backgroundColor: "#2D3436", paddingLeft: 10}} className="bo-core-header top-header">
                    <div style={{float: "left", paddingLeft: 2, width: "100%", display: "flex"}}>
                        <input ref={"quickFilterBox"} onKeyDown={this.onQuickFilterKeyDown}  onKeyUp={this.onFilterTextBoxChanged.bind(this)} onInput={this.onInput}
                               placeholder="🔍 Global search (press Shift-&#8593; and Shift-&#8595; to jump to column filters)"
                               className="new-design"
                               id={'manage-data-search'}
                               tabIndex={4}
                               autoComplete='off'
                               style={{width: "100%", height: 36, fontSize: 18, marginRight: 2}} type="search"
                        />
                        <div className="control-buttons">
                            <button onClick={this.onFilterTextBoxChanged.bind(this)}
                                    style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design">
                                <GlobalSearchHelpToolTip/>
                                <i className="fas fa-search"/>
                                Search
                            </button>
                            <button onClick={this.onClear} style={{marginRight: 2, height: 36}}
                                    id={'clear-btn'}
                                    title={'Clear applied filters and sorting (CTRL + ALT + R)'}
                                    className={"btn btn-new-design"}><i className="fas fa-broom"/> Clea<strong style={{fontSize: '14px'}} className={'shortcut-btn-letters'}>r</strong>
                            </button>
                            {this.props.currentBusinessObject.name.toLowerCase() !== "file version" ?
                                this.props.currentBusinessObject.name.toLowerCase() === 'file' ?
                                    <button onClick={this.uploadFileHandler}
                                            style={{marginRight: 2, height: 36}}
                                            className="btn btn-new-design"
                                            id={'new-file-btn'} title={'CTRL + ALT + N'}>
                                        <i className="fas fa-plus"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>N</strong>ew
                                    </button>
                                    :
                                <button onClick={this.onNewHandler.bind(this)} style={{marginRight: 2, height: 36}}
                                        className="btn btn-new-design"
                                        id={'new-instance-btn'} title={'CTRL + ALT + N'}>
                                    <i className="fas fa-plus"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>N</strong>ew
                                </button>
                                : null}
                            <button onClick={this.onEditHandler.bind(this)} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'edit-btn'} title={'CTRL + ALT + E'}>
                                <i className="fas fa-edit"/>
                                <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>E</strong>dit
                            </button>
                            {this.editRawBtn()}
                            <button
                                id={'inplace-edit-btn'}
                                onClick={this.onInplaceEdit}
                                style={{marginRight: 2, height: 36}}
                                className={"btn btn-new-design"}
                                title={'CTRL + ALT + L'}
                            >
                                <i className="fas fa-edit"></i> In-p
                                <strong style={{fontSize: '14px'}} className={'shortcut-btn-letters'}>l</strong>ace Edit
                            </button>
                            <button id='expand-btn' onClick={this.onResizeColumns}
                                style={{marginRight: 5}}
                                className={"btn btn-new-design"} title={'CTRL + ALT + P'}>
                                {this.state.resizeAction === ResizeActions.FIT_CONTENT ?
                                    <i className="fa fa-expand"> Ex<strong className={'shortcut-btn-letters'}>p</strong>and</i> :
                                    <i className="fas fa-compress-arrows-alt"> Fit Screen</i>}
                            </button>

                            <Menu
                                ref={"hamburger-menu"}
                                right
                                isOpen={this.state.burgerMenuIsOpen}
                                styles={hamburgerMenuStyles}
                                onClose={this.closeBurgerMenu}
                                onOpen={this.openBurgerMenu}
                            >
                                <div style={{
                                    width: 100,
                                    padding: 5,
                                    outline: "none"
                                }}>
                                    <div style={{
                                        marginLeft: 0,
                                        marginRight: 0,
                                        marginBottom: 2.5,
                                        marginTop: 2.5,
                                        textAlign: "center"
                                    }}>
                                        <button onClick={this.onBulkUpdate.bind(this)} style={{marginRight: 2, height: 36,  width: 170, marginBottom: 7}}
                                                className="btn btn-new-design"
                                                id={'bulk-update-button'} title={'CTRL + ALT + B'}>
                                            <i className="fas fa-edit"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>B</strong>ulk Update
                                        </button>

                                        {this.props.currentBusinessObject.name.toLowerCase() !== "file" ?
                                            <button onClick={this.onClone} style={{marginRight: 2, height: 36, width: 170, marginBottom: 7}}
                                                    className="btn btn-new-design"
                                                    id={'clone-instance-btn'} title={'CTRL + ALT + C'}>
                                                <i className="fas fa-clone"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>C</strong>lone
                                            </button> : null}

                                        {this.props.currentBusinessObject.name.toLowerCase() !== "file" ?
                                            <button onClick={() => this.onMerge()} style={{marginRight: 2, height: 36, width: 170, marginBottom: 7}}
                                                    className="btn btn-new-design" type="button" id={'merge-instance-btn'} title={'CTRL + ALT + G'}>
                                                <i  className={'fas fa-object-group'}/>
                                                <span style={{pointerEvents: "none", fontSize: 14}}> Mer<strong style={{fontSize: '14px'}} className={'shortcut-btn-letters icon-style-text'}>g</strong>e</span>
                                            </button> : null }

                                        {this.props.currentBusinessObject.name.toLowerCase() === "sgp batch import" ?
                                            <button onClick={this.onUpdateSGP.bind(this)} style={{marginRight: 2, height: 36, width: 170, marginBottom: 7}}
                                                    id={'sgp-btn'}
                                                    className="btn btn-new-design">
                                                <i className="fas fa-object-ungroup"/> SGP Update
                                            </button>
                                            : null}

                                        {this.props.currentBusinessObject.name.toLowerCase() === "file" ?
                                            (
                                                <button onClick={this.onDownload.bind(this)}
                                                        style={{
                                                            marginRight: 2,
                                                            height: 36, width: 170, marginBottom: 7
                                                        }}
                                                        className="btn btn-new-design"
                                                        id={'download-btn'}>
                                                    <i className="fas fa-download"/> D<strong style={{fontSize: '14px'}} className={'shortcut-btn-letters'}>о</strong>wnload
                                                </button>
                                            )
                                            : null}

                                        {this.props.currentBusinessObject.name.toLowerCase() !== 'file' ?
                                            <button onClick={this.onOpenImportDialog.bind(this)}
                                                    style={{marginRight: 2, height: 36, width: 170, marginBottom: 7}}
                                                    className="btn btn-new-design" type="button" id={'import-btn'} title={'CTRL + ALT + I'}>
                                                <i className={"fas fa-upload"} style={{pointerEvents: "none"}}/>
                                                <span style={{pointerEvents: "none", fontSize: 14}}> <strong style={{fontSize: 14}} className={'shortcut-btn-letters'}>I</strong>mport</span>
                                            </button>
                                            : null}

                                        {this.customImport()}

                                        <button onClick={this.onOpenExportDialog.bind(this)} style={{marginRight: 2, height: 36, width: 170, marginBottom: 7}}
                                                className="btn btn-new-design" type="button" id={'export-btn'} title={'CTRL + ALT + X'}>
                                            <i className={"fas fa-download"} style={{pointerEvents: "none"}}/>
                                            <span style={{pointerEvents: "none", fontSize: 14}}> E<strong style={{fontSize: '14px'}} className={'shortcut-btn-letters icon-style-text'}>x</strong>port</span>
                                        </button>

                                        <button onClick={this.onDeleteHandler.bind(this)} style={{height: 36, width: 170, marginBottom: 7}}
                                                className="btn btn-danger" id={'delete-btn'} title={'CTRL + ALT + D'}>
                                            <i className="fas fa-trash-alt"/> <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>D</strong>elete
                                        </button>
                                    </div>
                                </div>
                            </Menu>

                        </div>
                    </div>
                </div>
                <div style={{width: "100%", height: "calc(100% - 70px)", padding: 10, backgroundColor: '#2D3436'}}>
                    <div ref={"gridRef"} className={"ag-theme-balham-dark ag-grids"}
                         style={{width: "100%", height: "100%"}}/>
                    <LookupInstanceModal {...{save: this.onSaveLookupAttribute}} nextCellForEdit={this.nextCellForEdit} ref={this.lookupInstanceModalRef}/>
                    <AgGridFooter
                        totalCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                        loadedCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                        selectedCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().selectedItemsCount : 0}
                    />
                </div>
            </div>
        )
    }
}

const generateSortData = (sortModel: any, isInitialBuild): any => {
    const sort = {};
    if (isInitialBuild) {
        return {
            updated: 'desc'
        }
    }

    sortModel.map(item => {
        sort[item.colId] = item.sort
    });
    return sort;
};

const mapStateToProps = (state, ownProps) => {
    return {
        tagsSet: state.boCore.tagsSet,
        currentDataView: ownProps.currentDataView,
        currentBusinessObject: ownProps.currentBusinessObject,
        businessObjectsWrapper: state.boCore.businessObjectsWrapper,
        selectedSearch: state.savedSearchReducer.selectedSearch,
        locale: state.auth.locale
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteInstances: (ids: number[], onSuccessCallback: any) => {
            dispatch(deleteInstances(ids, onSuccessCallback));
        },
        deleteBOInstanceTags: (currentInstance, originalInstance, tags) => {
            dispatch(deleteBOInstanceTags(currentInstance, originalInstance, tags));
        },
        addBOInstanceTags: (currentInstance, originalInstance, tags) => {
            dispatch(addBOInstanceTags(currentInstance, originalInstance, tags));
        },
        downloadZip: (ids: number[], filename: string) => {
            dispatch(downloadZip(ids, filename));
        },
        setLastSearch: (obj: any) => {
            dispatch(setLastSearch(obj));
        },
        setSelectedSearch: (obj) => {
            dispatch(setSelectedSearch(obj))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageDataGrid)



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/ManageDataGrid/ManageDataGrid.tsx